import { Outlet } from 'react-router-dom'

export function SubscriptionSettingsShell() {
  return <Outlet />
}
